@use 'sass:map';
@use 'ui/styles/core';

body {
  overscroll-behavior-y: contain;
}

.logs {
  position: relative;

  &Header {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex: 2 1;
    justify-content: space-between;
    min-height: 66px;
    padding: 0 0 24px;

    &Select {
      width: 150px;

      &Mr16 {
        margin-top: -16px;
      }
    }

    &Operations {
      align-items: center;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      gap: 20px;
      margin-top: 16px;
    }

    &Label {
      margin: 0;
      min-width: 150px;
      padding: 0;
      text-align: left;
      white-space: nowrap;
    }

    &Input {
      position: relative;
      width: 350px;

      &Icon {
        &Search {
          background-color: inherit;
          border-radius: 0;
          border-style: solid;
          border-width: 0 0 0 1px;
          color: map.get(core.$colors, label);
          height: 40px;
          position: absolute;
          right: 0;
          width: 40px;
        }

        &Close {
          position: absolute;
          right: 12%;
          top: 12%;

          svg {
            height: 12px;
            width: 12px;
          }
        }
      }
    }
  }

  &Body {
    display: block;
    max-height: 360px;
    overflow: auto;
    overscroll-behavior: contain;
    position: relative;
    width: 100%;

    &Default {
      overflow: unset;
    }

    @media screen and (min-width: core.$fullHD) {
      max-height: 550px;
    }

    &Disabled {
      cursor: not-allowed;
      overflow-y: hidden;
    }

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      background-color: #eaf4f9;
      border-radius: 4px;
      width: 10px;
    }

    &::-webkit-scrollbar-thumb:vertical {
      background-color: map.get(core.$colors, tertiaryBlue);
      border: 1px solid map.get(core.$colors, label);
      border-radius: 4px;
      height: 2px !important;
      width: 10px;
    }
  }

  &Container {
    position: relative;
    min-height: 370px;

    @media screen and (min-width: core.$fullHD) {
      min-height: 560px;
    }
  }

  &Row {
    box-sizing: border-box;
    display: block;

    &Container {
      align-items: center;
      background-color: rgb(255, 255, 255);
      border-bottom-color: initial;
      border-bottom-style: initial;
      border-image: initial;
      border-left-color: transparent;
      border-left-style: solid;
      border-right-color: transparent;
      border-right-style: solid;
      border-top-color: rgba(0, 0, 0, 0.12);
      border-top-style: solid;
      border-width: 1px 1px 0;
      display: flex;
      flex-flow: row nowrap;
      font-size: 11px;
      font-family: 'Roboto Mono', monospace;

      &:hover {
        background-color: map.get(core.$colors, lightGrey);
      }
    }

    &Expander {
      display: flex;
      flex: 0 1 0%;
      flex-direction: column;
      justify-content: center;

      &Button {
        border-radius: 50%;

        &:hover {
          background-color: #e5e5e5 !important;

          & svg {
            color: map.get(core.$colors, accent);
          }
        }

        & svg {
          color: map.get(core.$colors, secondaryBlue);
          cursor: pointer;
          display: inline-block;
          height: 8px;
          transition: all 0.2s linear 0s;
          width: 8px;
        }
      }

      &Icon {
        transform: rotate(-90deg);
      }

      &Tooltip {
        margin-top: -4px;
      }
    }

    &Summary {
      cursor: pointer;
      display: flex;
      flex: 1 0 0%;
      flex-flow: column nowrap;
      line-height: 16px;
      overflow: hidden;
    }

    &Message {
      display: flex;
      flex: 1 1 0%;
      flex-direction: row;

      &Log {
        color: rgb(32, 33, 36);
        flex: 1 1 0%;
        overflow: hidden;
        padding: 6px 8px;
        text-overflow: ellipsis;
        white-space: nowrap;

        &Expanded {
          overflow: unset;
          text-overflow: unset;
          white-space: normal;
          word-break: break-word;
        }
      }
    }

    &Timestamp {
      color: rgb(60, 64, 67);
      display: inline-block;
      padding: 0 12px 8px 0;
    }
  }
}

.loading {
  &Base {
    min-height: 370px;
  }

  &Block {
    align-items: center;
    background-color: map.get(core.$colors, lightGrey);
    color: map.get(core.$colors, darkGrey);
    display: flex;
    font-family: 'Roboto Mono', monospace;
    height: 36px;
    justify-content: center;
    position: relative;
    width: 100%;

    &Up {
      top: 0%;
    }

    &Down {
      position: absolute;
      top: 100%;
    }
  }

  &Icon {
    color: map.get(core.$colors, darkGrey);
    height: 20px;
    margin-left: 5px;
    margin-right: 10px;
    width: 20px;
  }

  &Text {
    padding: 2px 0;

    &Base {
      @include core.font(core.$xl, core.$regular, map.get(core.$colors, label));
    }
  }
}

.noResult {
  height: 100%;
  width: 100%;
  min-height: 370px;
  background-color: map.get(core.$colors, lightGrey);
  display: flex;
  align-items: center;
  justify-content: center;
  @include core.font(core.$xl, core.$regular, map.get(core.$colors, label));
}
